export enum DispatchStatuses {
  /**
   * Отправлен и подписан
   */
  SENT_AND_SIGNED = 'sent_and_signed',

  /**
   * Отправлен и не подписан
   */
  SENT_AND_NOT_SIGNED = 'sent_and_not_signed',

  /**
   * Отклонен
   */
  REJECTED = 'rejected',

  /**
   * Не отправлен
   */
  NOT_SENT = 'not_sent',
}

export const DispatchStatusesTranslate: Record<string, string> = {
  [DispatchStatuses.SENT_AND_SIGNED]: 'Отправлен и подписан',
  [DispatchStatuses.SENT_AND_NOT_SIGNED]: 'Отправлен и не подписан',
  [DispatchStatuses.REJECTED]: 'Отклонен',
  [DispatchStatuses.NOT_SENT]: 'Не отправлен',
};

export const dispatch_statuses = Object.keys(DispatchStatusesTranslate).map((f: string) => ({
  text: DispatchStatusesTranslate[f],
  value: f,
}));

export enum DispatchReturnStatuses {
  /**
   * Отправлен
   */
  SENT = 'sent',

  /**
   * Зарегистрирован
   */
  REGISTERED = 'registered',

  /**
   * Проведен
   */
  ACCEPTED = 'accepted',

  /**
   * Отклонен
   */
  CANCELED = 'canceled',
}
